import { render } from "./SzCard.vue?vue&type=template&id=993a2ec8&scoped=true"
import script from "./SzCard.vue?vue&type=script&lang=ts"
export * from "./SzCard.vue?vue&type=script&lang=ts"

import "./SzCard.vue?vue&type=style&index=0&id=993a2ec8&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-993a2ec8"

export default script